import { render, staticRenderFns } from "./tm-notifier.vue?vue&type=template&id=70e9e943&scoped=true&"
import script from "./tm-notifier.vue?vue&type=script&lang=ts&"
export * from "./tm-notifier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9e943",
  null
  
)

export default component.exports